import SupportIcon from '@mui/icons-material/SupportAgent';
import { IconButton, Tooltip } from '@mui/material';
import React, { useCallback } from 'react';

const serviceNowUrl =
  'https://servicenow.i.mercedes-benz.com/esc?id=sc_cat_item&sys_id=062eec1f1b0c605093b43113dd4bcbf0&sysparm_variables=eyJjaG9vc2VfaXNzdWVfcmVsYXRlZCI6ImFwcGxpY2F0aW9uIHNlcnZpY2UiLCJ1X3NlcnZpY2VfaW5zdGFuY2UiOiJkZDIyMDk0ZmJmNzc0NzEwMWMwYjk5MTgzY2JjODY1NCIsInByb2R1Y3Rpb25fb25seSI6InRydWUiLCJpbXBhY3QiOiIzIiwidXJnZW5jeSI6IjMifQ==';

const ServiceNowButton = () => {
  const openServiceNow = useCallback(() => {
    window.open(serviceNowUrl, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <>
      <Tooltip title='Support ServiceNow'>
        <IconButton
          onClick={openServiceNow}
          aria-label='Support ServiceNow'
          sx={{
            color: '#ffffff',
            ':hover': { borderColor: 'rgba(255, 255, 255, 1)' },
          }}
        >
          <SupportIcon fontSize='medium' />
        </IconButton>
      </Tooltip>
    </>
  );
};

export { ServiceNowButton };
